import { useCallback, useMemo } from 'react';

import { useSWRWithToken } from './useSWRWithToken';
import { Data, Inquiry, Notification, Task, TaskStatus } from '../API';
import { isExpired } from '../utils';

type NotifyData = {
  notificationBadgeNum: number;
  taskBadgeNum: number;
};

const useNotifications = () => {
  const { data: notificationRows, mutate: mutateNotifications } = useSWRWithToken<Data<Notification>>(
    {
      url: '/notifications',
      ignoreError: true,
    },
    { refreshInterval: 30000 }
  );

  const { data: taskRows, mutate: mutateTasks } = useSWRWithToken<Data<Task>>(
    {
      url: '/tasks',
      ignoreError: true,
    },
    { refreshInterval: 30000 }
  );

  const data = useMemo<NotifyData>(
    () => ({
      notificationBadgeNum: notificationRows?.data?.filter((item) => !item?.isRead).length ?? 0,
      taskBadgeNum:
        taskRows?.data?.filter(
          (item) => item?.status === TaskStatus.TODO && !isExpired((item.reference as Inquiry).dueOn)
        ).length ?? 0,
    }),
    [notificationRows, taskRows]
  );

  const refetch = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    mutateNotifications();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    mutateTasks();
  }, [mutateNotifications, mutateTasks]);

  return { data, refetch };
};

export default useNotifications;
